export default __webpack_public_path__ + "static/media/tr_2.24651823.mp3";